import { DrawerFooter, Button } from "@growtherapy/sprout-ui";
import { useSetAtom } from "jotai";
import { ProviderDrawerState, drawerStateAtom } from "../state";

export function ClientInformationSchedulingDrawerFooter({
  onClickEditAppointment,
}: {
  onClickEditAppointment: () => void;
}) {
  return (
    <DrawerFooter>
      <Button use="secondary" onClick={onClickEditAppointment}>
        Edit appointment
      </Button>
    </DrawerFooter>
  );
}

export function ClientInformationSchedulingDrawerFooterWrapper() {
  const setDrawerState = useSetAtom(drawerStateAtom);
  return (
    <ClientInformationSchedulingDrawerFooter
      onClickEditAppointment={() =>
        setDrawerState(ProviderDrawerState.EDIT_APPOINTMENT)
      }
    />
  );
}
